import Constants from '@/constants/constants';
import Utils from '@/utils/utils';
const types = {
  GET_SHOW_TYPE: 'getShowType',
  GET_LANGUAGE: 'getLanguage',
  GET_FLOWCHARTS_THEME: 'getFlowChartsTheme',
  SET_MENU_COLLAPSE: 'SET_MENU_COLLAPSE',
  GET_MENUS_AND_BUTTONS: 'GET_MENUS_AND_BUTTONS',
  CHANGE_FLOW_DESIGN_BUTTON_STATUS: 'CHANGE_FLOW_DESIGN_BUTTON_STATUS',
  CHANGE_END_CRUMB: 'CHANGE_END_CRUMB',
  ADD_REQUEST_COUNT: 'ADD_REQUEST_COUNT',
  SUBTRACT_REQUEST_COUNT: 'SUBTRACT_REQUEST_COUNT',
  SET_REQUEST_END_TIME: 'SET_REQUEST_END_TIME',
  SET_PREV_REQUEST_END_TIME: 'SET_PREV_REQUEST_END_TIME',
  SET_GLOBAL_THEME_COLOR: 'SET_GLOBAL_THEME_COLOR',
  GET_CUR_SYSTEM_VERSION: 'GET_CUR_SYSTEM_VERSION',
  GET_SYS_PARAMS: 'GET_SYS_PARAMS'
};
const state = {
  showType: 'card',
  language: 'zh',
  flowChartsTheme: 'default',
  globalThemeColor: localStorage.getItem('globalThemeColor'),
  isCollapse: false,
  breadCrumbs: {},
  curTabName: '',
  prevRequestEndTime: 0,
  requestCount: 0,
  requestEndTimer: null
};
const actions = {
  changeEndCrumb(context, tabName) {
    context.commit(types.CHANGE_END_CRUMB, tabName);
  },
  getShowType(context) {
    const type = localStorage.getItem(Constants.common.ListShowType) || 'card';
    context.commit(types.GET_SHOW_TYPE, type);
  },
  getCurrentLanguage(context) {
    const language = localStorage.getItem('language') || process.env.VUE_APP_LANGUAGE;
    context.commit(types.GET_LANGUAGE, language);
  },
  getFlowChartsTheme(context) {
    const flowChartsTheme = localStorage.getItem('flowChartsTheme');
    context.commit(types.GET_FLOWCHARTS_THEME, flowChartsTheme);
  },
  setBreadCrumbs(context, fromAndToRoute) {
    // params.to.meta.isVisible === '1'表示是左侧菜单
    let { name,
      path,
      params,
      query, meta } = fromAndToRoute.to;
    const executionBranch = {
      true: () => {
        context.state.breadCrumbs[fromAndToRoute.to.path] = [{
          name,
          path,
          params,
          query,
          title: meta.title
        }];
      },
      false: () => {
        let whiteList = Constants.RouteWhiteList;
        if (fromAndToRoute.from.path && !whiteList.includes(fromAndToRoute.to.path)) {
          let fromBread = context.state.breadCrumbs[fromAndToRoute.from.path] || Utils.Session.getObject('lastedBreadCrumb');
          let toBread = context.state.breadCrumbs[fromAndToRoute.to.path];
          // 面包屑不存在，需要添加
          if (!toBread) {
            context.state.breadCrumbs[fromAndToRoute.to.path] = fromBread ? [...fromBread, {
              name,
              path,
              params,
              query,
              title: meta.title
            }] : [{
              name,
              path,
              params,
              query,
              title: meta.title
            }];
            // }
          } else {
            // 当已经存在相同的路由key值，需要更新最后名称
            toBread[toBread.length - 1].title = meta.title;
          }
        } else {
          context.state.breadCrumbs[fromAndToRoute.to.path] = Utils.Session.getObject('lastedBreadCrumb')
        }
      }
    }[fromAndToRoute.to.meta.isVisible === '1'];
    executionBranch?.();
    let obj = {};
    context.state.breadCrumbs[fromAndToRoute.to.path] = context.state.breadCrumbs[fromAndToRoute.to.path].reduce((cur, next) => {
      // eslint-disable-next-line no-unused-expressions
      obj[next.title] ? '' : obj[next.title] = true && cur.push(next);
      return cur;
    }, [])
    // 子系统面包屑 名称
    // 如果是同层路由跳转
    if (fromAndToRoute.to.name === fromAndToRoute.from.name && ['app_sys_detail', 'basic_sys_detail'].includes(fromAndToRoute.from.name)) {
      // 找到来源路由，替换最后一个名称
      const len = context.state.breadCrumbs[fromAndToRoute.to.path]
      context.state.breadCrumbs[fromAndToRoute.to.path] = context.state.breadCrumbs[fromAndToRoute.to.path].splice(len - 2, 1);
    }
    let lastedBreadCrumb = JSON.stringify(context.state.breadCrumbs[fromAndToRoute.to.path]);
    Utils.Session.setItem('lastedBreadCrumb', lastedBreadCrumb);
  },
  clearBreadCrumbs(context) {
    context.state.breadCrumbs = {}
  },
  setGlobalThemeColor(context, color) {
    context.commit(types.SET_GLOBAL_THEME_COLOR, color)
  }
};
const mutations = {
  [types.CHANGE_END_CRUMB](state, payload) {
    state.curTabName = payload
  },
  [types.GET_SHOW_TYPE](state, payload) {
    state.showType = payload;
  },
  [types.GET_LANGUAGE](state, payload) {
    state.language = payload;
  },
  [types.GET_FLOWCHARTS_THEME](state, payload) {
    state.flowChartsTheme = payload;
  },
  [types.ADD_REQUEST_COUNT](state) {
    state.requestCount = state.requestCount + 1
  },
  [types.SUBTRACT_REQUEST_COUNT](state) {
    state.requestCount = state.requestCount - 1
    if (state.requestCount <= 0) { state.requestCount = 0 }
  },
  [types.SET_GLOBAL_THEME_COLOR](state, payload) {
    state.globalThemeColor = payload
  }
};

export function removeHiddenMenus(showList) {
  if (typeof showList === 'object') {
    // 如果showList是一个object，遍历showList
    for (let i = 0; i < showList.length; i++) {
      let element = showList[i];
      if (element.isVisible === '0') {
        showList.splice(i, 1);
        // 注意删除了一项后，索引-1
        i--;
      } else {
        // 遍历其子节点
        removeHiddenMenus(element.children);
      }
    }
    return showList;
  } else {
    // 子节点不存在则结束
    return;
  }
}
const getters = {
  showType: (state) => state.showType,
  language: (state) => state.language,
  flowChartsTheme: (state) => state.flowChartsTheme,
  globalThemeColor: (state) => state.globalThemeColor,
  isCollapse: (state) => state.isCollapse,
  breadCrumbs: (state) => (routePath) => {
    return Constants.RouteWhiteList.includes(routePath) ? [] : state.breadCrumbs[routePath];
  },
  curTabName: (state) => state.curTabName
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
